import { gql } from '~gql-types/gql'

export const USER_ONLINE_QUERY = gql(`
    query UserOnline($userId: ID!) {
      user(id: $userId) {
        id
        legacyEid
        isOnline
      }
    }
  `)
